import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from 'src/shared/confirmation-modal/confirmation-modal.component';

export interface ConfirmationModalOptions {
  invertButtons?: boolean;
  confirmOnly?: boolean;
  headerBackgroundClass?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  backdrop?: boolean | 'static';
  keyboard?: boolean;
  onCancel?: () => void;
}

export function openConfirmationModal(
  modalService: NgbModal,
  header: string,
  message: string,
  onConfirm: () => void,
  options?: ConfirmationModalOptions,
): void {
  const modalRef = modalService.open(ConfirmationModalComponent, {
    backdrop: options?.backdrop ?? 'static',
    keyboard: options?.keyboard,
    size: options?.size ?? 'md',
    centered: true,
  });

  modalRef.componentInstance.header = header;
  modalRef.componentInstance.message = message;

  if (options?.invertButtons) {
    modalRef.componentInstance.invertButtons = options.invertButtons;
  }

  if (options?.confirmOnly) {
    modalRef.componentInstance.confirmOnly = options.confirmOnly;
  }

  if (options?.headerBackgroundClass) {
    modalRef.componentInstance.headerBackgroundClass = options.headerBackgroundClass;
  }

  modalRef.result.then(
    (result) => {
      if (result) {
        onConfirm();
      } else {
        options?.onCancel?.();
      }
    },
    () => options?.onCancel?.(),
  );
}
